export class ClientFamilyModel {
    family_client_no: number
    last_name: string
    first_name: string
    relation: string
    authority_id: number
    home_phone: string
    work_phone: string
    work_phone_ext: string
    client_no: number

    constructor(
        family_client_no: number,
        last_name: string,
        first_name: string,
        relation: string,
        authority_id: number,
        home_phone: string,
        work_phone: string,
        work_phone_ext: string,
        client_no: number
    ) {
        this.family_client_no = family_client_no
        this.last_name = last_name
        this.first_name = first_name
        this.relation = relation
        this.authority_id = authority_id
        this.home_phone = home_phone
        this.work_phone = work_phone
        this.work_phone_ext = work_phone_ext
        this.client_no = client_no
    }
}